module.exports = __webpack_public_path__ + "school/img/1.8d58953b.jpg";